import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import { selectIsAuthed } from "../selectors/userSelectors";
import { buildAnonymousLoginRedirect } from "../utils/onboardingDestination";

/**
 * Product-session gate (PRE-ZADRUZBU-PRIVATE-PRODUCT-BOUNDARY-B2).
 *
 * Mounts only behind AuthenticatedProductRuntime's bootstrap splash, so a
 * recoverable expired access token can finish the existing refresh path
 * before this decision runs. Terminal absence of an access token redirects
 * once to a safe `/login?next=` target without mounting product chrome.
 */
function RequireAuthenticatedSession() {
  const isAuthed = useSelector(selectIsAuthed);
  const location = useLocation();

  if (!isAuthed) {
    return (
      <Navigate to={buildAnonymousLoginRedirect(location)} replace />
    );
  }

  return <Outlet />;
}

export default RequireAuthenticatedSession;
